import React, { Component } from "react";
import { connect } from "react-redux";
import NotFoundV2 from "../NotFound/NotFoundV2";
import classnames from "classnames";
import { SvgIcon } from "../Common/Icons";
import _ from "i18n";
import ExtraSlideSideBar from "./ExtraSlideSideBar";
import { deleteExtraSlide, fetchExtraSlideList, saveExtraSlide } from "Thunks";
import {
  setExtraSlideListPaginationPage,
  setExtraSlideList,
  setExtraSlideUsable
} from "Actions";
import { onSuccess, onError } from "Utils";
import { NotificationManager } from "react-notifications";
import { ModalConfirm } from "tamtam-components";
import ExtraSlideItem from "./ExtraSlideItem";
import ExtraSlideListFetching from "./ExtraSlideListFetching";

class ExtraSlideList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddingExtraSlide: false,
      slideToUpdate: null,
      isUpdate: false,
      visibilityUpdate: false,
      isOpenModalDelete: false,
      extraSlideId: null
    };
  }

  render() {
    const {
      extraSlides,
      fetching,
      extraSlidesInModal,
      extraSlideUsable,
      dispatch,
      paginationPage,
      visibility,
      searchTitle, // handleUseExraSilde,
      categoryListSelected,
      withoutHeader
    } = this.props;
    const {
      isUpdate,
      isAddingExtraSlide,
      slideToUpdate,
      visibilityUpdate,
      isOpenModalDelete,
      extraSlideId
    } = this.state;
    return (
      <div>
        {fetching ? (
          <ExtraSlideListFetching extraSlidesInModal={extraSlidesInModal} />
        ) : (
          ""
        )}
        <div
          className={`row medium-11`}
          style={{ paddingLeft: withoutHeader ? "20px" : "" }}
        >
          <div className="row medium-12">
            {extraSlides && extraSlides.length ? (
              extraSlides.map(item => {
                return (
                  <ExtraSlideItem
                    key={`slide-${item.id}`}
                    slide={item}
                    visibilityUpdate={visibilityUpdate}
                    slideIdClicked={extraSlideUsable.slideIdClicked}
                    handleDisplayUpdateExtraSlide={
                      this.handleDisplayUpdateExtraSlide
                    }
                    deleteSlide={this.handleDeleteSlide}
                    hideSlide={this.handleHideSlide}
                    handleSlideClicked={this.handleSlideClicked}
                    // handleUseExraSilde={handleUseExraSilde}
                  />
                );
              })
            ) : !fetching ? (
              <NotFoundV2 />
            ) : (
              ""
            )}

            {!extraSlidesInModal ? this.renderAddBubble() : ""}
            {!extraSlidesInModal ? (
              <ExtraSlideSideBar
                isUpdate={isUpdate}
                isAddingExtraSlide={isAddingExtraSlide}
                onCancelNewExtraSlide={this.onCancelNewExtraSlide}
                slideToUpdate={slideToUpdate}
              />
            ) : (
              ""
            )}
            <ModalConfirm
              type={"delete"}
              isOpen={isOpenModalDelete}
              onCancel={() => this.setState({ isOpenModalDelete: false })}
              onConfirm={() => {
                dispatch(deleteExtraSlide(extraSlideId)).then(
                  res => {
                    this.onSuccess(res);
                    if (extraSlides.length === 1) {
                      dispatch(
                        setExtraSlideListPaginationPage(paginationPage - 1)
                      );
                    }
                    dispatch(
                      fetchExtraSlideList(
                        visibility,
                        searchTitle,
                        categoryListSelected
                      )
                    );
                    this.setState({ isOpenModalDelete: false });
                  },
                  err => this.onFailure(err)
                );
              }}
              inProcess={false}
              actionFailed={false}
              title={_("deleteConfirm")}
              text={_("deleteExtraSlide")}
              labelNo={_("cancel")}
              labelYes={_("delete")}
              labelError={"Error"}
            />
          </div>
        </div>
      </div>
    );
  }

  handleDisplayUpdateExtraSlide = slide => {
    this.onClickNewExtraSlide(slide);
  };

  handleSlideClicked = slide => {
    let extraSlideUsable = {
      slideIdClicked: slide ? slide.id : null,
      slideTitle: slide ? slide.label : "",
      slideContent: slide ? slide.layout.components[0].content : ""
    };

    let promise = new Promise((resolve, reject) => {
      this.props.dispatch(setExtraSlideUsable(extraSlideUsable));
      resolve("Promise resolved successfully");
    });

    promise.then(result => {
      this.props.handleUseExraSilde();
    });
  };
  handleHideSlide = slide => {
    const { dispatch, extraSlides, visibility, paginationPage } = this.props;

    dispatch(
      saveExtraSlide(
        slide.label,
        slide.layout.components[0].content,
        slide.id,
        slide.hidden === true ? "0" : "1",
        slide.category.id
      )
    ).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("visibilityUpdated")
        });
        extraSlides.filter(slid => slid.id === slide.id)[0].hidden =
          slide.hidden === true ? false : true;

        if (visibility !== "-1") {
          if (extraSlides.length === 1) {
            dispatch(setExtraSlideListPaginationPage(paginationPage - 1));
          }
          dispatch(
            setExtraSlideList(extraSlides.filter(slid => slid.id !== slide.id))
          );
        } else {
          dispatch(setExtraSlideList(extraSlides));
        }
        this.setState({
          ...this.state,
          visibilityUpdate: !this.state.visibilityUpdate
        });
      },
      err => {
        onError(err.response.data.errors[0].message);
      }
    );
  };

  handleDeleteSlide = extraSlideId => {
    this.setState({ isOpenModalDelete: true });
    this.setState({ extraSlideId: extraSlideId });
  };
  onSuccess(res, msg) {
    NotificationManager.success(_("extraSlideDeleted"));
  }

  onFailure(err) {
    NotificationManager.error(_("incompleteOperation"), _("error"));
  }

  onCancelNewExtraSlide = () => {
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.add("hide");
    document.body.classList.remove("hidden_overflow");

    this.setState({
      ...this.state,
      slideToUpdate: null,
      isAddingExtraSlide: false,
      isUpdate: false
    });
  };

  onClickNewExtraSlide = slide => {
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.remove("hide");
    document.body.classList.add("hidden_overflow");

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    this.setState({
      ...this.state,
      slideToUpdate: slide ? slide.slide : null,
      isAddingExtraSlide: true,
      isUpdate: !!slide
    });
  };

  renderAddBubble = () => {
    const { isAddingExtraSlide } = this.state;
    return (
      <div className="setting-bubbles">
        <div
          className={classnames(
            "circleSvg",
            isAddingExtraSlide ? "active openedExtraSlideSideBar" : ""
          )}
          onClick={() => this.onClickNewExtraSlide()}
        >
          <SvgIcon icon={"AddIcon"} />
          <span style={{ paddingLeft: "2.5rem" }}>{_("add")}</span>
        </div>
      </div>
    );
  };
}
// Connected Component
const mapStateToProps = state => ({
  fetching: state.extraSlideList.fetching,
  organizationUen: state.auth.currentOrganization.uen,
  paginationPage: state.extraSlideList.paginationPage,
  extraSlides: state.extraSlideList.extraSlides,
  visibility: state.extraSlideList.filter.visibility,
  searchTitle: state.extraSlideList.filter.searchTitle,
  categoryListSelected: state.extraSlideList.filter.category,
  extraSlidesInModal: state.preparePresentation.extraSlidesInModal,
  extraSlideUsable: state.preparePresentation.extraSlideUsable,
  withoutHeader: state.auth.withoutHeader
});

export default connect(mapStateToProps)(ExtraSlideList);



// WEBPACK FOOTER //
// ./src/components/ExtraSlides/ExtraSlideList.js